export const totalKeyReport04 = 'Tổng'